export abstract class BooleanService {
  public static fromString(booleanString: string): boolean {
    return !!booleanString && booleanString === 'true';
  }
}
